import auth from 'services/auth';
import {NavIconName} from './NavIcons';

export type NavItem = {
  path: string;
  label: string;
  icon: NavIconName;
  permission?: string;
  badge?: 'entries';
};

export const workspaceNav: NavItem[] = [
  {path: '/', label: 'Overview', icon: 'overview'},
  {path: '/my_events', label: 'Events', icon: 'events', permission: 'event:manage'},
  {path: '/entries', label: 'Entries', icon: 'entries', permission: 'entry:read', badge: 'entries'},
  {path: '/my_devices', label: 'Devices', icon: 'devices', permission: 'device:read'},
  {path: '/users', label: 'Users', icon: 'users', permission: 'user:read'}
];

export const adminNav: NavItem[] = [
  {path: '/logs', label: 'Activity logs', icon: 'logs', permission: 'log:read'},
  {path: '/all_devices', label: 'All devices', icon: 'allDevices', permission: 'device:admin'},
  {path: '/all_users', label: 'All users', icon: 'users', permission: 'user:read_all'},
  {path: '/roles', label: 'Roles & permissions', icon: 'roles', permission: 'role:read'},
  {path: '/configurations', label: 'Settings', icon: 'settings', permission: 'configuration:manage'}
];

export const visibleNav = (items: NavItem[]) => items.filter((item) => !item.permission || auth.hasPermission(item.permission));

export const isNavActive = (pathname: string, path: string) => {
  if (path === '/') return pathname === '/';
  return pathname === path || pathname.startsWith(`${path}/`);
};

export const crumbLabel = (pathname: string) => {
  const match = [...workspaceNav, ...adminNav].find((item) => isNavActive(pathname, item.path) && item.path !== '/');
  if (match) return match.label;
  if (pathname === '/') return 'Overview';
  return 'Workspace';
};

export const initialsFromName = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return 'LZ';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};
